// Keep transport failures distinct from missing content and authentication errors.
export const getErrorKind = (error) => {
  const status = Number(error?.status ?? error?.response?.status);
  if (status === 404 || status === 410) return 'not-found';
  if (status === 401) return 'unauthorized';
  if (status === 403) return 'forbidden';
  if (status === 429) return 'rate-limit';
  if (status === 408 || error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') return 'timeout';
  if (status >= 500) return 'server';
  if (error?.code === 'ERR_NETWORK' || (error?.request && !error?.response)) return 'network';
  return 'server';
};

export const getRequestErrorMessage = (error, fallback = '暂时无法完成操作，请稍后重试。') => {
  const status = Number(error?.status ?? error?.response?.status);
  // Form validation remains attached to the form rather than becoming a page error.
  if (status === 400 || status === 422) return typeof error?.detail === 'string' ? error.detail : fallback;
  return {
    'not-found': '请求的内容不存在或已被移走。',
    network: '暂时无法连接到博客，请检查网络后再试一次。',
    timeout: '连接等待超时，请稍后再试一次。',
    server: fallback,
    unauthorized: '登录状态已失效，请重新登录后再试。',
    forbidden: '当前账号没有执行此操作的权限。',
    'rate-limit': '操作有些频繁，请稍等一下再试。',
  }[getErrorKind(error)];
};
